import { useIntl } from 'react-intl';

import { AutoDismissFlag } from '@atlaskit/flag';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { token } from '@atlaskit/tokens';

import commonMessages from 'src/i18n/common';
import { ComponentFlagId, HandleDismissedType } from 'src/redux/flags/types';

import { messages } from './pull-request-retarget.i18n';

type Props = {
  id: ComponentFlagId;
} & HandleDismissedType;

export const PullRequestRetargetErrorFlag = ({
  id,
  ...otherProps
}: Props): JSX.Element => {
  const intl = useIntl();

  return (
    <AutoDismissFlag
      {...otherProps}
      id={id}
      description={intl.formatMessage(messages.retargetPullRequestErrorBody)}
      icon={
        <StatusErrorIcon
          spacing="spacious"
          label="error"
          color={token('color.icon.danger')}
        />
      }
      title={intl.formatMessage(commonMessages.errorHeading)}
    />
  );
};
